// src/components/ExtraActivity.jsx
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css"; // Import AOS styles

const ExtraActivity = () => {
    const activities = [
        {
            title: "Tree Plantation Initiative",
            description:
                "Planted and adopted a sapling on my college campus, promoting sustainability for three years.",
            period: "September 26, 2024",
            details:
                "Committed to enhancing green spaces by regularly maintaining the plant and raising awareness about the importance of tree planting and environmental conservation.",
        },
        // Add more activities as needed...
    ];

    // Initialize AOS
    useEffect(() => {
        AOS.init({
            duration: 1200,
            once: false,
        });
    }, []);

    return (
        <div className="container mx-auto p-6 shadow rounded-lg ubuntu-regular">
            <h2 className="text-3xl font-bold text-left mb-5">
                Extra Curricular Activities
            </h2>
            <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
                {activities.map((activity, index) => (
                    <div
                        key={index}
                        className=" p-6 rounded-lg shadow-lg"
                    >
                        {/* Small Screen Version */}
                        <div className="block lg:hidden" data-aos="zoom-in">
                            <h3 className="text-2xl font-semibold mb-2">
                                {activity.title}
                            </h3>
                            <p className=" mb-2">
                                {activity.description}
                            </p>
                            <p className=" italic mb-2">
                                Period: {activity.period}
                            </p>
                            <p className="">{activity.details}</p>
                        </div>

                        {/* Large Screen Version */}
                        <div className="hidden lg:block" data-aos="zoom-in-up">
                            <h3
                                className="text-2xl mb-2 "
                                data-aos="fade-right"
                            >
                                {activity.title}
                            </h3>
                            <p
                                className=" mb-2"
                                data-aos="zoom-left"
                            >
                                {activity.description}
                            </p>
                            <p
                                className=" italic mb-2"
                                data-aos="zoom-up-right"
                            >
                                Period: {activity.period}
                            </p>
                            <p className="" data-aos="zoom-up-left">
                                {activity.details}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ExtraActivity;
